import React from "react";

import { ToastContainer } from "@catchoftheday/cg-components";

export type NotificationToastContainerProps = {
  containerId: string;
};

export const NotificationToastContainer = ({
  containerId,
}: NotificationToastContainerProps) => {
  return (
    <ToastContainer
      containerId={containerId}
      autoClose={5000}
      containerStyles={{
        marginTop: "70px",
      }}
    />
  );
};
